import React from 'react'
import { PaymentErrorContent } from '../components/PaymentErrorContent'

const ERROR_MESSAGES = {
  payment_failure: '決済に失敗しました。再度お試しください。',
  payment_cancelled: '決済がキャンセルされました。',
  payment_expired: '決済の有効期限が切れました。再度お試しください。',
  coin_add_failure: 'コインの付与に失敗しました。お問い合わせください。',
  system_error: 'システムエラーが発生しました。問題が続く場合はお問い合わせください。',
  temporary_error: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
}

const DEFAULT_MESSAGE = 'お手続き中にエラーが発生いたしました。'

export const PaymentError = ({ errorType }) => {
  const errorMessage = ERROR_MESSAGES[errorType] || DEFAULT_MESSAGE

  const handleBackToCoinPurchase = () => {
    // Rails側のコイン購入画面に遷移
    window.location.href = '/external_payment/coin_purchase'
  }

  const handleReturnToApp = () => {
    window.location.href = 'mangabang://external_payment/coin_purchase_finish'
  }

  return (
    <PaymentErrorContent
      errorMessage={errorMessage}
      onBackToCoinPurchase={handleBackToCoinPurchase}
      onReturnToApp={handleReturnToApp}
      onLogoClick={handleBackToCoinPurchase}
    />
  )
}
